const technologies = [
  'React', 'Node.js', '.NET', 'Azure', 'TypeScript',
  'PostgreSQL', 'Docker', 'GitHub Actions', 'AI / Cursor', 'Salesforce',
];

export default function TechStrip() {
  return (
    <section className="tech-strip">
      <div className="section-inner">
        <p className="tech-strip-label">Technologies &amp; Platforms</p>
        <div className="tech-strip-items">
          {technologies.map((tech) => (
            <span key={tech} className="tech-chip">{tech}</span>
          ))}
        </div>
        <p className="tech-strip-note">
          In the AI era, the technology is rarely the constraint — if your stack isn't listed here, we can still help.
        </p>
      </div>
    </section>
  );
}
